import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { DEFAULT_LOCALE, LOCALES } from "./locale";

type Catalog = Record<string, unknown>;
const catalogModules = import.meta.glob<Catalog>(
  "../../../locales/*/messages.json",
  { eager: true, import: "default" }
);

export const resources = Object.fromEntries(
  LOCALES.map((locale) => {
    const suffix = `/locales/${locale.tag}/messages.json`;
    const entry = Object.entries(catalogModules).find(([path]) => path.endsWith(suffix));
    if (!entry) throw new Error(`Missing translation catalog for ${locale.tag}`);
    return [locale.tag, { translation: entry[1] }];
  })
);

void i18n.use(initReactI18next).init({
  resources,
  lng: DEFAULT_LOCALE,
  fallbackLng: DEFAULT_LOCALE,
  supportedLngs: LOCALES.map((locale) => locale.tag),
  defaultNS: "translation",
  interpolation: { escapeValue: false },
  returnNull: false
});

export default i18n;
